import React from 'react';

const VARIANT_CLASS = {
    neutral: 'bg-gray-100 text-gray-600',
    danger: 'bg-red-500 text-white',
    success: 'bg-emerald-100 text-emerald-700',
    info: 'bg-blue-100 text-blue-700',
    warning: 'bg-amber-100 text-amber-700',
    purple: 'bg-purple-100 text-purple-700',
};

const SIZE_CLASS = {
    xs: 'text-[9px] px-1.5 py-0.5 rounded-md',
    sm: 'text-[10px] px-2 py-0.5 rounded-full',
};

export default function AppBadge({
    variant = 'neutral',
    size = 'sm',
    className = '',
    children,
}) {
    const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.neutral;
    const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.sm;

    return (
        <span className={`${sizeClass} font-bold ${variantClass} ${className}`.trim()}>
            {children}
        </span>
    );
}
